export default "__VITE_ASSET__7a5ce7ed__"